import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Shell from "./components/Shell";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import SubscriptionsPage from "./pages/SubscriptionsPage";
import HomePage from "./pages/HomePage";
import FilesPage from "./pages/FilesPage";
import SettingsPage from "./pages/SettingsPage";
import ConnectPage from "./pages/ConnectPage";
import ExpensesPage from "./pages/ExpensesPage";
import ShipmentsPage from "./pages/ShipmentsPage";
import ChildrenPage from "./pages/ChildrenPage";
import AuditLogPage from "./pages/AuditLogPage";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { DriveProvider } from "./context/DriveContext";

function App() {
  useEffect(() => {
    document.title = "Портал";
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <DriveProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/connect"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <ConnectPage />
                  </ProtectedRoute>
                }
              />
              <Route
                element={
                  <ProtectedRoute>
                    <Shell />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<HomeRedirect />} />
                <Route
                  path="/prices"
                  element={<RequireRole><Navigate to="/prices/add" replace /></RequireRole>}
                />
                <Route path="/prices/add" element={<RequireRole><HomePage /></RequireRole>} />
                <Route path="/prices/files" element={<RequireRole><FilesPage /></RequireRole>} />
                <Route path="/shipments" element={<ShipmentsPage />} />
                <Route path="/children" element={<RequireRole><ChildrenPage /></RequireRole>} />
                <Route path="/expenses" element={<RequireRole><ExpensesPage /></RequireRole>} />
                <Route path="/subscriptions" element={<RequireRole><SubscriptionsPage /></RequireRole>} />
                <Route path="/settings" element={<RequireRole><SettingsPage /></RequireRole>} />
                <Route path="/audit" element={<RequireRole><AuditLogPage /></RequireRole>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </DriveProvider>
      </AuthProvider>
    </div>
  );
}

// Home: admin lands on Subscriptions; employee lands on Warehouse.
function HomeRedirect() {
  const { user } = useAuth();
  if (user?.is_admin) return <SubscriptionsPage />;
  return <Navigate to="/shipments" replace />;
}

function RequireRole({ children }) {
  const { user } = useAuth();
  if (!user?.is_admin) return <Navigate to="/warehouse" replace />;
  return children;
}

export default App;
